import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const STU_API = `${BASE}/api/student`;
const TOKEN_KEY = "asai_student_token";

export const getSToken = () => localStorage.getItem(TOKEN_KEY);
export const setSToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearSToken = () => localStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: STU_API, timeout: 25000 });
http.interceptors.request.use((c) => {
  const t = getSToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearSToken();
      if (!window.location.pathname.startsWith("/student/login")) window.location.href = "/student/login?expired=1";
    }
    return Promise.reject(err);
  }
);

const msg = (e, f) => new Error(e?.response?.data?.message || e?.response?.data?.detail || f);

export const sRegister = async (body) => {
  try { const { data } = await axios.post(`${STU_API}/auth/register`, body); setSToken(data.token); return data.user; }
  catch (e) { throw msg(e, "Registration failed."); }
};
export const sLogin = async (email, password) => {
  try { const { data } = await axios.post(`${STU_API}/auth/login`, { email, password }); setSToken(data.token); return data.user; }
  catch (e) { throw msg(e, "Login failed."); }
};
export const sForgot = async (email) => {
  try { return (await axios.post(`${STU_API}/auth/forgot-password`, { email })).data; }
  catch (e) { throw msg(e, "Request failed."); }
};
export const sReset = async (token, password) => {
  try { return (await axios.post(`${STU_API}/auth/reset-password`, { token, password })).data; }
  catch (e) { throw msg(e, "Reset failed."); }
};
export const sMe = async () => (await http.get("/auth/me")).data.user;
export const sLogout = async () => { try { await http.post("/auth/logout"); } catch { /* ignore */ } clearSToken(); };
export const sUpdateProfile = async (body) => {
  try { return (await http.patch("/profile", body)).data.user; }
  catch (e) { throw msg(e, "Update failed."); }
};

export const sOverview = async () => (await http.get("/overview")).data;
export const sContent = async (type) => (await http.get(`/list/${type}`)).data.items;
export const sAnnouncements = async () => (await http.get("/data/announcements")).data.items;
export const sPayments = async () => (await http.get("/data/payments")).data.items;
export const sProjects = async () => (await http.get("/projects")).data.items;
export const sSubmitProject = async (body) => { try { return (await http.post("/projects", body)).data; } catch (e) { throw msg(e, "Submission failed."); } };
export const sSubmitAssignment = async (id, body) => { try { return (await http.post(`/assignments/${id}/submit`, body)).data; } catch (e) { throw msg(e, "Submission failed."); } };
export const sTickets = async () => (await http.get("/tickets")).data.items;
export const sCreateTicket = async (body) => { try { return (await http.post("/tickets", body)).data; } catch (e) { throw msg(e, "Could not create ticket."); } };
